import { RSVPResponse, WeddingInvitation } from '../../types/invitation';

export interface RSVPResponseWithTable extends RSVPResponse {
  tableName?: string;
  tableId?: number;
  notificationSent?: boolean;
  notificationFailed?: boolean;
  notificationSentAt?: Date;
}

export interface RSVPTrackerProps {
  inviteCode: string;
  refreshTrigger?: number;
  onDataChange?: () => void;
  currentInvitation?: WeddingInvitation;
}

export interface PhysicalInvitationStats {
  totalRequests: number;
  totalGuests: number;
  addressList: Array<{ guestName: string; guestCount: number; postalAddress: string }>;
}

export interface SeatAssignmentStats {
  totalAttending: number;
  assignedSeats: number;
  unassignedSeats: number;
  assignmentRate: number;
}

export const EXPORTABLE_FIELDS = [
  { key: 'guestName', label: '賓客姓名', required: true },
  { key: 'guestSide', label: '親友分類', required: false },
  { key: 'guestEmail', label: '電子郵件', required: false },
  { key: 'contactPhone', label: '聯絡電話', required: false },
  { key: 'attending', label: '出席狀態', required: true },
  { key: 'guestCount', label: '人數', required: false },
  { key: 'specialRequests', label: '特殊需求', required: false },
  { key: 'message', label: '留言', required: false },
  { key: 'submittedAt', label: '提交時間', required: false }
] as const;
